<div class="chart-container">
  <ngx-charts-polar-chart [view]="view" [results]="polarChartData" [scheme]="'vivid'" [animations]="true"
    [legend]="false" [xAxis]="true" [yAxis]="true" [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="''"
    [yAxisLabel]="''" (select)="onSelect($event)">
  </ngx-charts-polar-chart>
</div>

<!-- <ngx-charts-polar-chart
  [view]="[700, 300]"
  [scheme]="'vivid'"
  [legend]="true"
  [showXAxisLabel]="true"
  [showYAxisLabel]="true"
  [xAxis]="true"
  [yAxis]="true"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [results]="polarChartData"
  (select)="onSelect($event)">
</ngx-charts-polar-chart> -->